import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { Box, rem } from '@mantine/core';
import { EdgeLabelRenderer } from '@xyflow/react';
import { CSSProperties, ReactNode } from 'react';

interface Props {
	edgeId: string;
	x: number;
	y: number;
	labelStyle?: CSSProperties;
	children: ReactNode;
}

/** Hover styling hangs off the `edge-label` class in CapChart. */
export const EdgeLabel = ({ edgeId, x, y, labelStyle, children }: Props) => (
	<EdgeLabelRenderer>
		<Box
			pos="absolute"
			bg="white"
			bd="1px solid gray.4"
			px={6}
			py={4}
			c="dark.8"
			lh={1}
			style={{
				borderRadius: rem(4),
				zIndex: 1004,
				pointerEvents: 'all',
				...labelStyle,
				transform: `translate(-50%, -50%) translate(${x}px,${y}px)`,
			}}
			className="edge-label"
			data-edge-id={edgeId}
			data-testid={TEST_ELEMENT_IDS.GSC_EDGE_LABEL}
		>
			{children}
		</Box>
	</EdgeLabelRenderer>
);
